import { useParams } from 'react-router-dom';
import Colleges from "./sublist/colleges";
import GlobalGradeList from "../../pages/common/globalgradelist";
import GlobalGoalQuestions from "../../pages/common/globalgoalquestions";
import GlobalCollegeList from "../../pages/common/globalcollegelist";
import Student911TopMenu from "../studentInfo/student911topmenu"
import PageNotes from "../../pages/common/pagenotesnew";
import { useAuth } from "../../../usercontext";

export default function InstructorStudentGradeList() {
  let { slug } = useParams();
  const { profile, setProfile } = useAuth();

  return (
    <>
      <Student911TopMenu slug={slug} activeMenu={"GoalGrades"} />
      <PageNotes
        type={"Instructor"}
        pageName={"GoalGrades"}
        studentId={slug}
        instructorId={profile.id}
      />
      <div className="tak-instruct-group">
        <div className="row">
          <div className="col-md-12">
            <GlobalGradeList slug={slug} />
          </div>
        </div>
      </div>
      <GlobalGoalQuestions slug={slug} />
      {/* <Colleges slug={slug} />
      <GlobalCollegeList slug={slug} isStudent={false} /> */}
    </>
  );
}
